// Libraries
import moment from 'moment'

// Services
import store from '../store'

// Utilities
import isEmpty from './isEmpty'
import Language from './languageUtil'
import Logger from './loggerUtil'

class CreditCardUtil {
  static formatCardsByType (bridgePayCardTypes, cards) {
    const newCards = []
    for (let i = 0; i < cards.length; i++) {
      const newCard = this.formatCardByCardType(bridgePayCardTypes, cards[i])

      if (newCard) {
        newCards.push(newCard)
      }
    }

    return newCards
  }

  static formatCardByCardType (bridgePayCardTypes, cardObj) {
    let cardType = null

    for (const key in bridgePayCardTypes) {
      if (bridgePayCardTypes[key] === cardObj.cardType) {
        cardType = key
      }
    }

    const tempMonth = `0${cardObj.expirationMonth.toString()}`
    cardObj.expirationYear %= 100
    cardObj.expirationMonth = tempMonth.substring(tempMonth.length - 2)
    cardObj.cardNumber = `•••• •••• •••• ${cardObj.cardNumber.substring(cardObj.cardNumber.length - 4)}`
    cardObj.cardType = (cardType || '').toLowerCase()

    return cardObj
  }

  static getBridgePayCardType (cardTypeName) {
    const cardTypes = store.state.cards.bridgePayCardTypes // Must ensure cardTypes is filled before running this

    if (!cardTypeName) {
      throw new Error(Language.$t('global.card_type_not_found_error') + Object.keys(cardTypes).join(', '))
    }

    let matchingCardTypeProp

    const cardTypeProps = Object.getOwnPropertyNames(cardTypes)

    for (let i = 0; i < cardTypeProps.length; i++) {
      if (cardTypeProps[i].toLowerCase() === cardTypeName.toLowerCase()) {
        matchingCardTypeProp = cardTypeProps[i]
      }
    }

    const bridgePayCardType = cardTypes[matchingCardTypeProp]

    if (bridgePayCardType === undefined || bridgePayCardType == null) {
      throw new Error(Language.$t('global.card_type_not_found_error') + Object.keys(cardTypes).join(', '))
    }

    return bridgePayCardType
  }

  /**
   * Sorts an array of cards by their created date (most recent first).
   * @param {Array} cards - An array of card objects.
   * @return {Array} Returns the sorted card array.
   */
  static sortCards (cards) {
    try {
      if (Array.isArray(cards) === false) {
        throw new Error('Cards should be an array')
      }

      return cards.sort((cardA, cardB) => {
        if (cardA.createdDate === undefined || cardB.createdDate === undefined) {
          return 0
        }

        const dateA = moment(cardA.createdDate)
        const dateB = moment(cardB.createdDate)

        if (dateA.isBefore(dateB)) {
          return 1
        }

        if (dateA.isAfter(dateB)) {
          return -1
        }

        return 0
      })
    } catch (error) {
      Logger.error('Error on sortCards')
      Logger.debug(error)
      throw error
    }
  }

  /**
   * Gets a specific card from a card array based on its cardIds
   * @param {Object} cardIds an object of cardIds and their associated provider
   * @param {Array} cards an array of card objects
   * @return {Object} returns the card if it is found
   */
  static getCardFromCards (cardIds, cards) {
    try {
      if (Array.isArray(cards) === false) {
        throw new Error('Cards should be an array')
      }

      return cards.find(card => this.isSameCard(cardIds, card.cardIds))
    } catch (error) {
      Logger.error('Error on getCardFromCards')
      Logger.debug(error)
      throw error
    }
  }

  /**
   * Compares two sets of card IDs to see if they are the same
   * @param {Array} aCardIds an array of cardId objects and their associated provider
   * @param {Array} bCardIds an array of cardId objects and their associated provider
   * @return {Boolean} returns true if the cards are the same, and false if not
   */
  static isSameCard (aCardIds, bCardIds) {
    try {
      if (isEmpty(aCardIds) || isEmpty(bCardIds) || aCardIds.length !== bCardIds.length) {
        return false
      }

      for (let i = 0; i < aCardIds.length; i++) { // Loop through each type of id on first card
        const aCardId = aCardIds[i]
        const matchingIds = bCardIds.filter(id => id.type === aCardId.type) // Find matching id type on second card
        if (isEmpty(matchingIds) === true) {
          return false // No matching type found on the second card
        }

        const bCardId = matchingIds[0]
        if (aCardId.id !== bCardId.id) {
          return false // Matching type does not have matching id
        }
      }
      return true
    } catch (error) {
      Logger.error('Error on isSameCard')
      Logger.debug(error)
      throw error
    }
  }
}

export default CreditCardUtil
